{
  "zh-CN": {
    "sublines": {
      "hangarGuide": {
        "headline": "也许我们应该改变这一点 ;)",
        "add": "如何添加飞船?",
        "edit": "如何编辑飞船?",
        "wishlist": "如何将飞船添加到愿望清单?",
        "fleetchart": "舰队图表?",
        "public": "公开 URL?",
        "groups": "如何创建和更新群组?"
      },
      "impressum": {
        "general": "General Information (according to § 5 TMG)",
        "disclaimer": "免责声明",
        "copyright": "版权",
        "thirdpartycontent": "点数",
        "sponsors": "赞助商",
        "liabilityInternal": "Limitation of liability for internal content",
        "liabilityExternal": "Limitation of liability for external links"
      }
    }
  }
}
